import { v4 as uuid } from "uuid";
import {Base} from "./Base";
import {Collection} from "./Collection";
import { IconLayoutNavbarExpandFilled } from "@tabler/icons-react";

export class Model extends Base {
    public key?:string;
    public uid:string = uuid().slice(0, 8);
    public dirty:boolean = false;
    public validate:boolean = false;
    public isInit:boolean = true;
    public changes:object = new Object();
    public _keys:any = null;

        constructor(data:any = null) {
            super();
            if(data) {
                this.createModel(data);
            }

            return this;
        }



        public createModel(data, collection:any = {}) {
            let self = this;

            if(Array.isArray(data) ) {
                let keyName = "items";
                self[keyName] = new Collection(data, collection[keyName]);
            } else if(data) {
            Object.keys(data).forEach( function( keyName, $index){
                if(Array.isArray(data[keyName]) && data[keyName] != null){
                    if(collection[keyName]) {
                        self[keyName] = new Collection(data[keyName], collection[keyName]);
                    } else {
                        self[keyName] = new Collection(data[keyName], null, keyName);
                    }
                } else if(typeof data[keyName] == 'object' && data[keyName] != null ) {
                    if(collection[keyName]) {
                        const ModelName = collection[keyName];
                        self[keyName] = new ModelName(data[keyName]);
                    } else {
                        self[keyName] = new Model(data[keyName]);
                    }
                } else if(typeof data[keyName] == 'object' && collection[keyName] ) {
                    const ModelName = collection[keyName];
                    self[keyName] = new ModelName(data[keyName]);

                } else {
                    switch( typeof self[keyName] ) {
                        case 'string':
                            self[keyName] = (data[keyName] == 'null') ? "" : data[keyName];
                            break;
                        case 'number':
                            self[keyName] = data[keyName] as number;
                            break;
                        case 'undefined':
                            self[keyName] = (data[keyName] == 'null') ? "" : data[keyName];
                            break;
                        default:
                            self[keyName] = data[keyName];
                            break;
                    }
                }
            })
            }
            return self;
        }

        static createCollection=(data:Array<any>, className:any) => {
            let collection = new Collection();
            let self = this;
            data.forEach( function(item) {
                let model = new className(item);
                collection.set(model);
            });

            return collection;
        }
        
        getChanges(fields = null, asModel = false) {
            let self = this;
            let data = {};
            if(asModel) {
                data = Object.create(this);
            }
            Object.keys(self).forEach( function( keyName, $index){
                if(keyName.indexOf('key') >= 0) {
                    self.changes[keyName] = self[keyName];
                } else 
                if(fields === null || (Array.isArray(fields) && fields.includes(keyName)  )) {
                    if(self[keyName] instanceof Collection){
                        console.debug(keyName, self[keyName]);
                        let collectionCHanges = self[keyName].getChanges(); //getData(fields, true, asModel);
                        if(Array.isArray(collectionCHanges) && collectionCHanges.length > 0) {
                            data[keyName] = collectionCHanges;
                        }
                    }
                }
            })
            Object.assign(data, self.changes); 
            if(self["_keys"] && Array.isArray(self["_keys"])) {
                delete data["_keys"];
                for(let i in self["_keys"]) {
                    let keyName = self["_keys"][i];
                    if(data[keyName] == undefined) {
                        data[keyName] = "";
                    }
                }
            }

            return data;

        }

        getData(fields = null, asModel = false) {
            let self = this;
            let data = {};
            if(asModel) {
                data = Object.create(this);
            }
            Object.keys(self).forEach( function( keyName, $index){
                if(fields === null || (Array.isArray(fields) && fields.includes(keyName)  )) {
                    if(self[keyName] instanceof Collection){
                        data[keyName] = self[keyName].getData(); //getData(fields, true, asModel);
                    } else if(self[keyName] instanceof Model){
                        data[keyName] = self[keyName].getData(fields, asModel);
                    } else {
                        let val = self[keyName];
                        if(keyName.substring(0,1) == '_') {
                            keyName = keyName.substr(1, keyName.length-1);
                        }
                        data[keyName] = val;
                    }
                }
            })

            return data;

        }


        public getValue(key, subObj = null) {
            let retVal = null;
            let currentObj = this;
            if(subObj && this[subObj] && typeof this[subObj] == 'object') {
                currentObj = this[subObj];
            }
            let objectKeys = Object.keys(currentObj);
            if(objectKeys.includes(key) || objectKeys.includes('_'+key) ) {
                retVal = currentObj[key];
                if(typeof currentObj[key] == 'number') {
                    if(!retVal) {
                        retVal = 0;
                    } else {
                        retVal = (retVal) as number;
                    }
                }
            }

            key = key.toString();
            let restOfKeys:any;
            if(key.includes(".")) {
                restOfKeys = key.split('.');
                retVal = this;
                for(let ckey in restOfKeys) {
                    retVal = retVal[restOfKeys[ckey]];
                }
            }


            return retVal;
        }


        public setValue(key:string, val, force=false) {
            let objectKeys = Object.keys(this);
            key = key.toString();
            let restOfKeys:any;
            if(key.includes(".")) {
                restOfKeys = key.split('.');
                key = restOfKeys[0];
            }
            if(!force && objectKeys.includes(key) || objectKeys.includes('_'+key) ) {
                if(typeof this[key] == 'number') {
                    val = (val as number);
                }
                
                
                
                 if(this[key] !== null && typeof this[key] == 'object') {
                    this[key] = {...this[key], [restOfKeys[1]]: val};
                    this.changes[key] = {...this[key], [restOfKeys[1]]: val}
                 } else {
                this[key] = val;
                this.changes[key] = val;
                 }
                this.validate = true;
                this.dirty = true;
            } else if(force) {
                this[key] = val;
            }
            return this;
        }

        public hasField(fieldName) {
            let retVal = false;
            if(this[fieldName]) {
                retVal = true;
            }
            if(!retVal && fieldName.substring(0,1) == '_') {
                fieldName = fieldName.substr(1, fieldName.length-1);
                if(this[fieldName]) {
                    retVal = true;
                }
            }
            return retVal;

        }

        public hasValue(field, val) {
            let retVal = false;
            if(val instanceof Array) {
                retVal = val.includes( this[field] );
            }

            return retVal;
        }
}
